import axios from "axios";

export const FETCH_POSTS = 'FETCH_POSTS';
export const FETCH_POST = 'FETCH_POST';

export const fetchPosts = () => {
  return function(dispatch) {    
    axios.get(`${process.env.REACT_APP_API_URL}?username=${process.env.REACT_APP_USERNAME}`)
         .then(response => {
            dispatch({
                type: FETCH_POSTS,
                payload: response
            });
         });
  };
};

export const fetchPost = (idPost) => {
  return function(dispatch) {    
    axios.get( `${process.env.REACT_APP_API_URL}/${idPost}`)
         .then(response => {
            dispatch({
                type: FETCH_POST,
                payload: response
            });
         });
  };
};






// WEBPACK FOOTER //
// ./src/actions/posts.js